const passwordContainers = document.querySelectorAll('[data-password-toggle]');

passwordContainers.forEach((passwordContainer)=>{

    //
    const passwordField   = passwordContainer.querySelector('[type="password"]');
    const icon            = passwordContainer.querySelector('[data-password-toggle-icon]');          
    
    if (passwordField != null && icon != null) {
        passwordContainer.addEventListener('click', (event)=>{                      
            if (event.target.matches('[data-password-toggle-icon]')) {
                if (passwordField.type === "password") {
                    passwordField.type = "text";
                    icon.classList.remove('fa-eye');
                    icon.classList.add('fa-eye-slash');
                } else {
                    passwordField.type = "password";
                    icon.classList.remove('fa-eye-slash');
                    icon.classList.add('fa-eye');
                }
            }
        });
    }

});